import { useParams } from 'react-router-dom'
import projectData from './Project.json'


const ProjectDetails = () => {
  const { id } = useParams()

  const project = projectData.projects.find(
    (item) => item.id.toLowerCase() === id.toLowerCase()
  )

  if (!project) return <p className="not-found">Project not found</p>
  const handleDownload = () => {
    if (!project.brochure) {
      alert("Brochure not available for this project");
      return;
    }

    const link = document.createElement("a");
    link.href = process.env.PUBLIC_URL + project.brochure;
    link.download = `${project.name.replace(/\s+/g, "_")}_Brochure.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
       <div className='backdiv'>

      <div className="project-image-wrapper">
        <img
          src={process.env.PUBLIC_URL + project.image}
          alt={project.name}
          className="img-cover"
          loading="lazy"
          onError={(e) => (e.target.src = "/projects/placeholder.jpg")}
        />

        <div className="image-overlay">
          <h2 className='sapt-head-white'>{project.name}</h2>
          <p className='detail_location'>{project.location}</p>
          <div className="chips">
          <p className="chip">{project.category}</p></div>
        </div>
      </div>


      <div className="project-container">
     
        <section className="section">
          <h2 className='deatil_heading'>Project Overview</h2>
          <p className="main-content">{project.overview}</p>
        </section>

        {/* HIGHLIGHTS */}
        {project.highlights && (
          <section className="section">
            <h2 className='deatil_heading'>Key highlights</h2>
            <div className="chips">
              {project.highlights.map((item, index) => (
                <span key={index} className="chip">{item}</span>
              ))}
            </div>
          </section>
        )}
     
        {project.amenities && (
          <section className="section usp">
            <h2 className='deatil_heading'>Amenities</h2>
            <ul>
              {project.amenities.map((item, index) => (
                <li className='usp_tick' key={index}>✔ {item}</li>
              ))}
            </ul>
          </section>
        )}

   <div className="cta">
    <a href='/contact-us'>
          <button>Request Call Back</button></a>
          <button className="outline" onClick={handleDownload}>Download Brochure</button>
        </div>
 
      </div>
    </div>
  )
}

export default ProjectDetails
